import React from 'react';
import { Route } from 'react-router-dom';
import { ResourceDialog } from '../ProgramResources';
import UnitDescriptionPanel from './UnitDescriptionPanel';
import UnitImagePanel from './UnitImagePanel';
import UnitInformationPanel from './UnitInformationPanel';
import UnitLessonsPanel from './UnitLessonsPanel';
import UnitResourcesSection from './UnitResourcesSection';
import UnitVideoPanel from './UnitVideoPanel';

// The edit unit page's sections as child routes, under the page on both mounts. Paths match
// unitEditSections.
const unitEditRoutes = (
  <>
    <Route index element={<UnitInformationPanel />} />
    <Route element={<UnitLessonsPanel />} path="lessons" />
    <Route element={<UnitImagePanel />} path="image" />
    <Route element={<UnitVideoPanel />} path="video" />
    <Route element={<UnitResourcesSection />} path="resources">
      <Route element={<ResourceDialog />} path="new" />
      <Route element={<ResourceDialog />} path=":resourceId/edit" />
    </Route>
    <Route element={<UnitDescriptionPanel />} path="description" />
  </>
);

export default unitEditRoutes;
